import React from 'react'
import MaskedInput from 'react-text-mask'

import { Input, InputProps } from './Input'

export const DateInput: React.FC<InputProps> = (props: InputProps) => (
  <Input
    label="Birth date(mm/dd/yyyy)"
    inputComponent={MaskedInput}
    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
    {...props}
  />
)
